export const wsUrl = 'wss://norma.nomoreparties.space/orders';
